import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import {changeCartFeature} from "../../actions/actionFunctions";

const NoteEditor = (props) => {

  let {intl, cartItem, closeEditor, editorVisible, cartItemId, dbFeatureId, quoteIndex, changeCartFeature} = props;
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    setNoteText(cartItem.noteText || "");
  }, [cartItemId, dbFeatureId, quoteIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  const onNoteChange = (e) => {
    setNoteText(e.target.value);
    if (!editorVisible) {
      onNoteSaveClick(); // set parent's editor visible
    }
  };

  const onNoteFocus = () => {
    if (noteText && !editorVisible) {
      onNoteSaveClick(); // set parent's editor visible
    }
  };

  const onBlur = () => {
    changeCartFeature(Object.assign({}, cartItem, {
      noteText
    }), true);
  };

  const onNoteSaveClick = () => {
    changeCartFeature(Object.assign({}, cartItem, {
      noteText
    }), true);
    closeEditor();
  };

  return (
    <div className={"product-note" + (noteText && !editorVisible ? " product-note--with-text" : "")
    + (editorVisible ? " product-note--active" : "")}>
      {/*<p className="product-note__text">{noteText}</p>*/}
      <textarea className="product-note__textarea ui-textarea"
                placeholder={intl.formatMessage({id: "shoppingCart.featureInCartAddNoteLink"})}
                value={noteText}
                onFocus={onNoteFocus}
                onBlur={onBlur}
                onChange={onNoteChange} />
      <button className="product-note__button ui-button2 ui-button2--green" onClick={onNoteSaveClick}>
        <FormattedMessage id="quotingTool.featureInfo.saveNoteButton"/>
      </button>
    </div>
  )
};

NoteEditor.propTypes = {
  cartItem: PropTypes.object.isRequired,
  dbFeatureId: PropTypes.number.isRequired,
  closeEditor: PropTypes.func,
}

const mapStateToProps = (store, ownProps) => {
  return {
    quoteIndex: ownProps.cartItem.currentQuote,
  };
};

const mapDispatchToProps = {
  changeCartFeature,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NoteEditor)
);
